import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";

import PepperChat from "assets/images/pepper_chat.svg";
import Countdown from "react-countdown";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { firestore } from "lib/firebase";
import { useRecoilValue } from "recoil";
import { instanceIdAtom } from "lib/globalState";
import { useEffect, useState } from "react";
import { currentAppAtom } from "../lib/globalState";

//controllare refresh

const PepperOccupato = ({ms = 5, tokenInfo}) => {
	const theme = useTheme();
	const instanceId = useRecoilValue(instanceIdAtom);
	const appId = useRecoilValue(currentAppAtom);
	const [queueCount] = useDocumentData(firestore.doc(`/apps/${appId}/waiting_queue/${instanceId}`));
	const [startingDate] = useState(Date.now() + ms + 2000 + (((3 * 60 * 1000) - ms) * 0.5));

	useEffect(() => {
		if (queueCount?.count === 0) {
			onEnd();
		}
	}, [queueCount]);

	const onEnd = () => {
		window.location = "/scansiona";
	};

	return (
		<Page bg={theme.palette.background.paper}>
			<Stack spacing={2} sx={{
				display: "flex",
				flex: 1
			}}>
				<Box
					sx={{
						flex: 1,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column"
					}}
				>
					<CenteredText>
						<Typography variant="h5" sx={{paddingInline: "2rem", color: theme.palette.white.main}}>
							Pepper è occupato con un altro utente.
						</Typography>
					</CenteredText>

					<CenteredText>
						<img src={PepperChat} alt={"pepper chat umano"}/>
					</CenteredText>
					<CenteredText>
						<Typography variant="h5" sx={{paddingInline: "1.2rem", color: theme.palette.white.main}}>
							Attendi
						</Typography>
						<Typography variant="h5" sx={{paddingInline: "1.2rem", color: theme.palette.white.main}}>
							<Countdown
								renderer={({
														 minutes,
														 seconds
													 }) => `${minutes > 0 ? `${minutes} minut${minutes === 1 ? "o" : "i"} e` : ""} ${seconds} second${seconds === 1 ? "o" : "i"}`}
								date={startingDate}
								onComplete={() => onEnd()}/>
						</Typography>
						<Typography variant="h5" sx={{paddingInline: "1.2rem", color: theme.palette.white.main}}>
							prima di riprovare ad interagire con il robot. Fai attenzione a non aggiornare la pagina o chiudere il
							browser.
						</Typography>
					</CenteredText>

				</Box>

			</Stack>
		</Page>
	);
};

export default PepperOccupato;